import { render, staticRenderFns } from "./LocalAddInfo.vue?vue&type=template&id=0e525145&scoped=true"
import script from "./LocalAddInfo.vue?vue&type=script&lang=js"
export * from "./LocalAddInfo.vue?vue&type=script&lang=js"
import style0 from "./LocalAddInfo.vue?vue&type=style&index=0&id=0e525145&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e525145",
  null
  
)

export default component.exports